"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _Container = _interopRequireDefault(require("../components/Container"));

var _PageHeader = _interopRequireDefault(require("../components/PageHeader"));

var _LoaderWithMessage = _interopRequireDefault(require("../components/LoaderWithMessage"));

var _expired = _interopRequireDefault(require("@wisetack/assets/img/expired.svg"));

var _SessionExpiredPageModule = _interopRequireDefault(require("./SessionExpiredPage.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SessionExpiredPage = function SessionExpiredPage(props) {
  var inactivity = props.location && props.location.pathname.includes('inactivity');
  var isPrequal = props.location && props.location.search.includes('prequal=true');
  var continuePath = (0, _reactRedux.useSelector)(function (state) {
    if (state.consumer) {
      return state.consumer.continuePath;
    }

    if (state.merchant) {
      return "/";
    }
  });
  var isLoading = (0, _reactRedux.useSelector)(function (state) {
    if (state.consumer) {
      return state.consumer.isLoading;
    }
  });

  var handleOnButtonClick = function handleOnButtonClick() {
    if (continuePath) {
      props.history.push(continuePath);
    }
  };

  var ContinueButton = function ContinueButton() {
    if (!continuePath) {
      if (isLoading) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _SessionExpiredPageModule["default"].message
      }, "Please use your ", isPrequal ? 'prequal' : 'payment', " link to log in.");
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "row",
      style: {
        paddingLeft: "10px",
        paddingRight: "10px"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      "data-test-id": "continue",
      className: (0, _classnames["default"])("btn", "btn-block", _SessionExpiredPageModule["default"]["continue"]),
      onClick: handleOnButtonClick
    }, "LOGIN TO CONTINUE")));
  };

  return /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_PageHeader["default"], {
    progress: "0"
  }, /*#__PURE__*/_react["default"].createElement("div", null, "Session expired"), /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement("img", {
    className: _SessionExpiredPageModule["default"].expired,
    src: _expired["default"],
    alt: "expired"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _SessionExpiredPageModule["default"].message
  }, "Your session has timed out", inactivity ? ' due to inactivity' : '', ". Please log back in to continue", continuePath !== '/' ? ' where you left off' : '', "."), /*#__PURE__*/_react["default"].createElement(_LoaderWithMessage["default"], {
    loading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(ContinueButton, null));
};

var _default = SessionExpiredPage;
exports["default"] = _default;